import React from "react";
import {
  CSidebarBrand,
  CSidebarNav,
  CNavItem,
  CNavGroup,
} from "@coreui/react";
import {
  cilUser,
  cilSettings,
  cilList,
  cilUserPlus,
  cilGroup,
  cilShieldAlt,
  cilEnvelopeOpen,
  cilMoney,
} from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { NavLink, useNavigate } from "react-router-dom";

type SidebarProps = {
  onSelect?: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ onSelect }) => {
  const handleSelect = () => {
    if (window.innerWidth < 768 && onSelect) {
      onSelect();
    }
  };

  return (
    <div>
      <CSidebarBrand className="fw-bold d-flex justify-content-center align-items-center pt-4">
        VISION PRO
      </CSidebarBrand>
      <CSidebarNav className="px-2 py-2 mt-4">
        <CNavItem className="d-flex align-items-center">
          <NavLink
            to="/app-users"
            onClick={handleSelect}
            className={({ isActive }) =>
              isActive
                ? "nav-link sidebar-link active-sidebar"
                : "nav-link sidebar-link"
            }
          >
            <CIcon icon={cilUser} className="me-2" />
            <span>App Users</span>
          </NavLink>
        </CNavItem>

        <CNavItem className="d-flex align-items-center">
          <NavLink
            to="/reports-analytics"
            onClick={handleSelect}
            className={({ isActive }) =>
              isActive
                ? "nav-link sidebar-link active-sidebar"
                : "nav-link sidebar-link"
            }
          >
            <CIcon icon={cilList} className="me-2" />
            <span>Reports & Analytics</span>
          </NavLink>
        </CNavItem>

        <CNavItem className="d-flex align-items-center">
          <NavLink
            to="/loan-and-investment"
            onClick={handleSelect}
            className={({ isActive }) =>
              isActive
                ? "nav-link sidebar-link active-sidebar"
                : "nav-link sidebar-link"
            }
          >
            <CIcon icon={cilMoney} className="me-2" />
            <span>Loan & Investment</span>
          </NavLink>
        </CNavItem>

        <CNavItem className="d-flex align-items-center">
          <NavLink
            to="/support-ticket"
            onClick={handleSelect}
            className={({ isActive }) =>
              isActive
                ? "nav-link sidebar-link active-sidebar"
                : "nav-link sidebar-link"
            }
          >
            <CIcon icon={cilUserPlus} className="me-2" />
            <span>Support Ticket</span>
          </NavLink>
        </CNavItem>

        <CNavGroup
          toggler={
            <>
              <CIcon icon={cilGroup} className="me-2" />
              <span>User Management</span>
            </>
          }
        >
          <CNavItem className="d-flex align-items-center">
            <NavLink
              to="/user-management/user-list"
              onClick={handleSelect}
              className={({ isActive }) =>
                isActive
                  ? "nav-link sidebar-link active-sidebar"
                  : "nav-link sidebar-link"
              }
            >
              <CIcon icon={cilUser} className="me-2" />
              <span>User List</span>
            </NavLink>
          </CNavItem>

          <CNavItem className="d-flex align-items-center">
            <NavLink
              to="/user-management/roles"
              onClick={handleSelect}
              className={({ isActive }) =>
                isActive
                  ? "nav-link sidebar-link active-sidebar"
                  : "nav-link sidebar-link"
              }
            >
              <CIcon icon={cilShieldAlt} className="me-2" />
              <span>Roles</span>
            </NavLink>
          </CNavItem>
        </CNavGroup>

        <CNavItem className="d-flex align-items-center">
          <NavLink
            to="/notifications"
            onClick={handleSelect}
            className={({ isActive }) =>
              isActive
                ? "nav-link sidebar-link active-sidebar"
                : "nav-link sidebar-link"
            }
          >
            <CIcon icon={cilEnvelopeOpen} className="me-2" />
            <span>Notifications</span>
          </NavLink>
        </CNavItem>

        <CNavItem className="d-flex align-items-center">
          <NavLink
            to="/settings"
            onClick={handleSelect}
            className={({ isActive }) =>
              isActive
                ? "nav-link sidebar-link active-sidebar"
                : "nav-link sidebar-link"
            }
          >
            <CIcon icon={cilSettings} className="me-2" />
            <span>Settings</span>
          </NavLink>
        </CNavItem>
      </CSidebarNav>
    </div>
  );
};

export default Sidebar;
